<nav class="meganav"
     role="navigation"
     (offClick)="close()"
     [offClickOff]="!client.isTouchy || client.isCms"
     offClickFilter=".meganav__content">
    <ul>
        @for (item of items; track $index; let i = $index) {

        <!-- <ng-container *ifCustomerAllowed="item.visibility"> -->
        <li class="inline-block"
            [attr.cy-navCategory]="item.link ? item.link : 'empty'"
            [toggleClass]="'is-active'"
            [toggleClassBy]="[meganavToggleGroupId, i]">
            <div class="w-12 pos-absolute bottom-0 border"></div>
            <href [link]="isCms ? null : item.link">
                <span class="link meganav__item"
                      [sizeClass]="'XMS: p1, L:p2'"
                      [ngClass]="item.color || ''"
                      (mouseenter)="handleMouseEnter(i)"
                      (click)="handleClick(i)"
                      *iCms="'text' of item">
                </span>
            </href>
        </li>
        <!-- </ng-container> -->

        }

    </ul>
</nav>